import { HeroImageInputs } from './HeroImage';

export const heroImageTransformer = (node): HeroImageInputs => {
    return {
        imageAlt: node.relationships?.field_image?.field_media_image_1?.alt,
        image: node.relationships?.field_image?.relationships
            ?.field_media_image_1.localFile?.childImageSharp?.gatsbyImageData,
        policy: true,
        hideArrows: true,
        homepage: true,
        heroText: node.field_body?.value,
        heroTitle: node.field_hero_text_title,
        hideHero: node.hide_hero,
        eyebrowText: node.field_eyebrow_text,
    };
};
